module.exports = __webpack_public_path__ + "img/404.0e033fb0.svg";